import React, { useContext } from 'react';
import { DishFullInfoContext, IDishFullInfoContext } from '../../../../../../../dishFullInfoState/dishFullInfoContext';
import FullInfoField from 'components/FullInfoField/FullInfoField';

export const OpenPriceMaxThreshold: React.FC = () => {
	const { dishForFullInfo } = useContext<IDishFullInfoContext>(DishFullInfoContext);

	return <FullInfoField label="openPriceMaxThresholdLabel" value={dishForFullInfo?.openPriceMaxThreshold} />;
};
